import { graphql } from 'gatsby';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import React from 'react';
import Banner from '../components/Banner';
import Layout from '../components/Layout';
import IntroContent from '../components/IntroContent';
import CallToActionBlocks from '../components/CallToActionBlocks';
import LatestNews from '../components/LatestNews';
import ImageContent from '../components/ImageContent';

const HomePageTemplate = ({
  data: {
    home: {
      seoMetaTags,
      title,
      bannerLinkText,
      bannerLinkPage,
      bannerImage,
      introductionHeading,
      introductionContent,
      callToActionBlocks,
      imageContent,
    },
  },
}) => (
  <Layout>
    <HelmetDatoCms seo={seoMetaTags} />
    <main>
      <Banner
        title={title}
        linkPage={bannerLinkPage}
        linkText={bannerLinkText}
        image={bannerImage}
      />
      <IntroContent
        heading={introductionHeading}
        content={introductionContent}
      />
      <CallToActionBlocks
        items={callToActionBlocks[0].instance.callToActionBlocks}
      />
      <LatestNews />
      <ImageContent
        heading={imageContent[0].heading}
        content={imageContent[0].content}
        image={imageContent[0].image}
        flip={imageContent[0].flip}
      />
    </main>
  </Layout>
);

export const HomePageTemplateQuery = graphql`
  query HomePageTemplateQuery {
    home: datoCmsHome {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      title
      bannerLinkPage {
        slug
      }
      bannerLinkText
      bannerImage {
        fluid(
          maxHeight: 680
          maxWidth: 1600
          imgixParams: { auto: "compress", fit: "crop", h: "680", w: "1600" }
        ) {
          ...GatsbyDatoCmsFluid
        }
        alt
      }
      introductionHeading
      introductionContent
      callToActionBlocks {
        instance {
          callToActionBlocks {
            id
            image {
              fluid(
                maxHeight: 400
                maxWidth: 600
                imgixParams: {
                  auto: "compress"
                  fit: "crop"
                  h: "400"
                  w: "600"
                }
              ) {
                ...GatsbyDatoCmsFluid
              }
              alt
            }
            text
            link {
              ... on DatoCmsHome {
                slug
              }
              ... on DatoCmsPage {
                slug
              }
              ... on DatoCmsNewsArchive {
                slug
              }
              ... on DatoCmsNewsSingle {
                slug
              }
            }
          }
        }
      }
      imageContent {
        heading
        content
        image {
          fluid(
            maxHeight: 680
            maxWidth: 600
            imgixParams: { auto: "compress", fit: "crop", h: "680", w: "600" }
          ) {
            ...GatsbyDatoCmsFluid
          }
          alt
        }
        flip
      }
    }
  }
`;

export default HomePageTemplate;
